import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

const useStyles = makeStyles({
    root: {
        width: 500,
    },
});

class BottomNav extends Component {
    constructor(props) {
        super(props);
        
    }
    isJumperLogged = () => {
        //to find is there is admin logged in or jumper logged in.
        let role = localStorage.getItem("role");
        if (role==='jumper') {
            return true;
        }
        else {
            return false;
        }
    }

    handelTabs = (value) => {
        switch (value) {
            case 0:
                this.props.history.push('/daily-activity')
                return
            case 1:
                this.props.history.push({pathname :'/load-manager', initial:true } )
                return
            case 2:
                this.props.history.push('/detail')
                return

            default:
                break;
        }
    }

    render() {

        let { componentToRender } = this.props;
        return this.isJumperLogged()?(
            <div className="bottomNav">
                <BottomNavigation
                    value={componentToRender}
                    onChange={(event, newValue) => {
                        this.handelTabs(newValue)
                        // setValue(newValue);
                    }}
                    showLabels
                    className={useStyles.root}
                >
                    <BottomNavigationAction label="Activity" icon={<i className="fa fa-history" />}/>
                    <BottomNavigationAction label="Home"  icon={<i className="fa fa-home" />}/>
                    <BottomNavigationAction label="Details"  icon={<i className="fa fa-user" />} />
                </BottomNavigation>
            </div>

        ):null
    }
}

export default BottomNav;